import $ from 'jquery'
import Swiper from 'swiper/bundle'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.numerical-services-block__slider')

  if (!wrapper.length) {
    return
  }

  new Swiper(wrapper[0], {
    slidesPerView: 1.3,
    spaceBetween: 20,
    breakpoints: {
      576: {
        slidesPerView: 2.1,
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
      },
      1300: {
        slidesPerView: 3,
      },
      1550: {
        slidesPerView: 3.35,
      },
    },
  })
}

$('.numerical-services-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=cc-numerical-services',
    initializeBlock
  )
}

const setWidth = () => {
  const blocks = document.querySelectorAll('.numerical-services-block')
  if (blocks) {
    ;[...blocks].map((block) => {
      const container = document.querySelector('.entry-content--main')

      if (!container) {
        return
      }

      const containerWidth = container.clientWidth
      const mainWidth = document.documentElement.clientWidth
      const calc = block.querySelector(
        '.numerical-services-block__width-calculator'
      )
      const calcWidth = calc.clientWidth
      const spaceWidth = (mainWidth - containerWidth) / 2
      const allowedWith = spaceWidth + calcWidth

      const img = block.querySelector(
        '.numerical-services-block__image-wrapper'
      )

      if (window.matchMedia('(max-width: 991.98px)').matches) {
        img.style.width = `${mainWidth - spaceWidth}px`
        return
      }

      img.style.width = `${allowedWith - 60}px`
    })
  }
}

setWidth()
window.addEventListener('load', setWidth)
window.addEventListener('resize', setWidth)

const setPos = () => {
  const blocks = document.querySelectorAll('.numerical-services-block')
  if (blocks) {
    ;[...blocks].map((block) => {
      const container = document.querySelector('.entry-content--main')

      if (!container) {
        return
      }

      const containerWidth = container.clientWidth

      const button = block.querySelector('.numerical-services-block__action')
      const text = block.querySelector(
        '.numerical-services-block__action .vn-a-content'
      )
      const textWidth = text.clientWidth

      const mainWidth = document.documentElement.clientWidth
      const spaceWidth = (mainWidth - containerWidth) / 2
      const calc = block.querySelector(
        '.numerical-services-block__width-calculator'
      )
      const calcWidth = calc.clientWidth

      const icon = block.querySelector('.numerical-services-block__icon')

      if (window.matchMedia('(max-width: 991.98px)').matches) {
        button.style.width = `${mainWidth - spaceWidth}px`
        icon.style.setProperty('--left', 'auto')
        icon.style.setProperty('--left2', 'auto')
        return
      }

      icon.style.setProperty('--left', `${textWidth + spaceWidth + 30}px`)
      icon.style.setProperty(
        '--left2',
        `${spaceWidth + containerWidth - calcWidth - 65 / 2 + 20}px`
      )
    })
  }
}

setPos()
window.addEventListener('load', setPos)
window.addEventListener('resize', setPos)
